import type { BrandName } from "./brand-names";
import type { BrandConfig } from "./types";
import { novaBrand } from "./nova";
import { fitupBrand } from "./fitup";
import { stageBrand } from "./stage";

/**
 * App-wide tokens for every brand (`COLORS`, MUI theme, feature styles).
 *
 * Typed as `Record<BrandName, BrandConfig>` so a missing brand is a compile
 * error rather than a silent fallback. See `HUB_THEMES` for the profile-hub
 * counterpart — both are keyed by the same union, so `BRAND_NAMES` is the only
 * list you edit.
 */
export const BRANDS: Record<BrandName, BrandConfig> = {
  nova: novaBrand,
  fitup: fitupBrand,
  stage: stageBrand,
};

export { BRAND_NAMES, DEFAULT_BRAND, resolveBrandName } from "./brand-names";
export type { BrandName } from "./brand-names";
export { HUB_THEMES } from "./hub-themes";
export type { BrandConfig } from "./types";
export type { HubTheme, ActivityIconStyle } from "./hub-theme.types";
